import type {ReactNode} from 'react';
import {Button} from '~library/atoms/Button';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import {useTracking} from '~library/context/tracking/tracking-context';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import * as styles from './AcctDrawerItem.module.scss';

type AcctDrawerItemProps = {
  text: string;
  tabIndex: number;
  dataQaId: string;
  icon?: ReactNode;
  type?: 'button' | 'link';
  href?: string;
  onClick?: () => void;
};
export const AcctDrawerItem = ({
  type = 'link',
  icon,
  dataQaId,
  text,
  href,
  tabIndex,
  onClick,
}: AcctDrawerItemProps) => {
  const isLargishAndUp = useIsLargishAndUp();
  const {track} = useTracking();

  const handleClick = () => {
    track({
      dataQaId,
      href: href || undefined,
      text,
    });
    if (onClick) {
      onClick();
    }
  };

  const handleLinkClick = () => {
    track({
      dataQaId,
      href: href || undefined,
      text,
    });
  };

  return type === 'button' ? (
    <Button
      className={styles.drawerCtaItem}
      onClick={handleClick}
      tabIndex={tabIndex}
      data-qa-id={dataQaId}
      variant="unstyled-button"
    >
      {icon}
      <Typography variant={isLargishAndUp ? 'paragraph3' : 'paragraph2'}>{text}</Typography>
    </Button>
  ) : (
    <Link
      className={styles.drawerCtaItem}
      href={href as string}
      data-qa-id={dataQaId}
      onClick={handleLinkClick}
    >
      {icon && icon}
      <Typography variant={isLargishAndUp ? 'paragraph3' : 'paragraph2'}>{text}</Typography>
    </Link>
  );
};
